import React, { useState, useEffect } from 'react';
import expandIcon from '../assets/images/expand.svg'; // Adjust the path as necessary
import collapseIcon from '../assets/images/collapse.svg'; // Adjust the path as necessary

const Product3Legend = ({ legendData, onOpacityChange, dataType }) => {
    const [isExpanded, setIsExpanded] = useState(true);
    const [opacityValue, setOpacityValue] = useState(0.8); // Single opacity value for the entire layer

    const toggleContent = () => {
        setIsExpanded(!isExpanded);
    };

    // Handle opacity change for the entire layer
    const handleOpacityChangeInternal = (value) => {
        const newOpacity = parseFloat(value);
        setOpacityValue(newOpacity);
        onOpacityChange(newOpacity); // Notify parent component
    };

    // Reset opacity when dataType changes
    useEffect(() => {
        setOpacityValue(0.8); // Default opacity
    }, [dataType]);

    const base64ToDataUrl = (base64) => `data:image/png;base64,${base64}`;

    return (
        <>
            <div className="card legendCard p3 border-0">
                <div className="card-header px-2 py-1 border-0 d-flex mb-0 align-items-center">
                    <div><h3 className="legend-title f-12px mb-0 pe-3" style={{ whiteSpace: 'nowrap', width: '246px' }}>
                        {dataType === 'exceed' ? 'Return period (years)' : 'Basin and River Layers'}
                    </h3></div>
                    <div>
                        <button onClick={toggleContent} className="toggle-button px-0" style={{ background: 'none', border: 'none', cursor: 'pointer' }}>
                            <img
                                src={isExpanded ? collapseIcon : expandIcon}
                                alt={isExpanded ? 'Collapse' : 'Expand'}
                                className="toggle-icon"
                            />
                        </button>
                    </div>
                </div>

                {isExpanded && (
                    <div className="gradient-legend">
                        {dataType === 'exceed' && legendData && (
                            <img src={base64ToDataUrl(legendData)} alt="Risk Hazard Legend" style={{ height: 'auto', margin: '0px 5px', width: '290px' }} />
                        )}
                        {/* Single Opacity Slider */}
                        <div style={{ margin: '10px 0 10px 10px' }}>
                            <input
                                className="ml-2"
                                type="range"
                                min="0"
                                max="1"
                                step="0.1"
                                value={opacityValue}
                                onChange={(e) => handleOpacityChangeInternal(e.target.value)}
                                style={{
                                    width: '100px',
                                    height: '5px',
                                    borderRadius: '10px',
                                    appearance: 'none',
                                    background: `linear-gradient(to right, #105586 ${opacityValue * 100}%, #ccc 0%)`,
                                }}
                            />
                            <span style={{ fontSize: '10px', fontWeight: '600', marginLeft: '10px' }}>
                                {opacityValue.toFixed(1)}
                            </span>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

export default Product3Legend;